import {Component, EventEmitter, inject, Output} from '@angular/core';
import { Router } from '@angular/router';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import { AgeVerificationService } from '@core/services/age-verification.service';
import {StoryblokService} from '@core/services/storyblok.service';

@Component({
  selector: 'app-age-verification-popup',
  templateUrl: './age-verification-popup.component.html',
  styleUrls: ['./age-verification-popup.component.scss'],
  standalone: true,
  imports: [CommonModule, NgOptimizedImage]
})
export class AgeVerificationPopupComponent {
  storyblokService = inject(StoryblokService);
  ageVerificationService = inject(AgeVerificationService);
  router = inject(Router);
  @Output() closed = new EventEmitter<void>();

  onYes(): void {
    this.ageVerificationService.setAgeVerified(true);
    this.closed.emit();
  }

  onNo(): void {
    this.ageVerificationService.setAgeVerified(false);
    window.location.href = 'https://www.google.com';
    this.closed.emit();
  }
}
